import React from 'react';
import { Icon } from '@iconify/react';
import './footer.less'

const Index = () => {
    const currentYear = new Date().getFullYear();
    return (
        <div className='bg-yellow footer'>
        <div className='iconWrapper'>
        <a href='https://www.linkedin.com/in/tefe-mebuiefene-31b0831b4/' target="_blank" rel="noreferrer"><Icon icon="simple-icons:linkedin"  className='icon' width="30"/></a>
        <a href="https://github.com/glorytefe" target="_blank" rel="noreferrer"><Icon icon="simple-icons:github"  className='icon' width="30"/></a>
        <a href="https://twitter.com/TefeGlory?t=cn-KpaTHxopXiRay4LP34Q" target="_blank" rel="noreferrer"><Icon icon="simple-icons:twitter"  className='icon' width="30"/></a>

        </div>
        <p>&copy;{currentYear} Tefe</p>

        </div>
    );
}

export default Index;
